/**
* 基础菜单 商品管理
*/
<template>
  <div class="contianer">
    <div class="date-box">
      {{timeSlot}},今天是{{today}}。
    </div>
    <div class="flex-around">
      <div class="head-message relative">
        <div class="head"><img src="/static/img/Default-avatar.png" alt=""></div>
        <div class="person-message">
          <p class="name">{{dashboardData.user_name}}</p>
          <p class="company-name">{{dashboardData.seller_name}}</p>
        </div>
        <div class="last-login-time absolute" style="right: 25px">上次登录时间：{{lastLoginTime}}</div>
      </div>
      <div class="product-message">
        <div class="text">在售商品</div>
        <div><span class="product-num" @click="gotoGood()">{{dashboardData.selling_product_num}}</span>件</div>
      </div>
      <div class="service-order-message">
        <div class="text">待审核售后服务单</div>
        <div><span class="service-order-num" @click="gotoAftersale()">{{dashboardData.waiting_after_service_num}}</span>单
        </div>
      </div>
      <div class="send-goods-message">
        <div class="text">需要发货订单</div>
        <div><span class="send-goods-num" @click="gotoOrder()">{{dashboardData.waiting_send_num}}</span>单</div>
      </div>
    </div>
    <div class="table">
      <div class="table-title"><span class="line"></span>发货统计</div>
      <template>
        <el-table size="small" :data="listData" style="width: 100%;">
          <el-table-column prop="title" label="全部客户">
          </el-table-column>
          <el-table-column prop="send_count_month" label="过去1个月">
          </el-table-column>
          <el-table-column prop="send_count_year" label="过去12个月">
          </el-table-column>
        </el-table>
      </template>
    </div>
    <div class="table">
      <div class="table-title"><span class="line"></span>平台收入</div>
      <template>
        <el-table
          :data="tableData"
          style="width: 100%">
          <el-table-column
            prop="title"
            label="全部产品">
          </el-table-column>
          <el-table-column
            prop="count_month"
            label="过去1个月">
          </el-table-column>
          <el-table-column
            prop="count_year"
            label="过去12个月">
          </el-table-column>
        </el-table>
      </template>
    </div>

    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="titre" :visible.sync="dialogFormVisible" center v-if="currentIndex != dialogIndex">
      <el-form>
        <div class="condition" v-html="contre">

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" v-if="timeShow">( {{ time }} ) 秒后取消</el-button>
        <el-button type="primary" v-if="closeShow" @click="closePop">同意入驻商须知</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {indexData, indexNotice, agreeNotice} from "../../api/basisMG";

  export default {
    data: () => {
      return {
        loading: false, // 显示加载
        dialogFormVisible: true,
        time: '',
        timeShow: true,
        closeShow: false,
        today: '',
        timeSlot: '',
        dashboardData: {},
        listData: [],
        tableData: [],
        lastLoginTime: '',
        thenId: '',
        contre: '',
        titre: '',
        circulate: [],
        currentIndex: 0,
        dialogIndex: 0,
        naticeData: []
      }
    },
    // 公告弹窗
    mounted() {
      this.Time()
    },
    destroyed() {
      clearTimeout(this.timer)
    },
    // 注册组件
    components: {},
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getDate()
      this.getData()
      this.getDaty()
      this.lastLoginTime = localStorage.getItem('lastLoginTime')
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      Time() {
        var countTime = setInterval(() => {
          this.time -= 1
          if (this.time < 1) {
            clearInterval(countTime);
            this.timeShow = false;
            this.closeShow = true;
          }
        }, 1000)
      },
      getDate() {
        let date = new Date();
        let year = date.getFullYear() // 获取年
        let month = date.getMonth() + 1 // 获取月
        let strDate = date.getDate()
        let hour = date.getHours()
        this.today = year + '年' + month + '月' + strDate + '日';
        if (hour < 12) {
          this.timeSlot = '上午好'
        } else if (12 < hour && hour < 14) {
          this.timeSlot = '中午好'
        } else if (14 < hour && hour < 19) {
          this.timeSlot = '下午好'
        } else {
          this.timeSlot = '晚上好'
        }
      },
      getData() {
        this.loading = true
        indexData()
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.dashboardData = res.content;
              localStorage.setItem('seller_name', res.content.seller_name)
              let listObj = {
                title: '发给客户',
                send_count_month: res.content.send_count_month,
                send_count_year: res.content.send_count_year
              }
              this.listData.push(listObj)
              let tableObj1 = {
                title: '订单量',
                count_month: res.content.order_count_month,
                count_year: res.content.order_count_year
              }
              let tableObj2 = {
                title: '销售额',
                count_month: res.content.sales_count_month,
                count_year: res.content.sales_count_year
              }
              this.tableData.push(tableObj1)
              this.tableData.push(tableObj2)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      getDaty() {
        this.loading = true
        indexNotice()
          .then(res => {
            this.loading = false
            if (res.success == false) {
              // this.$message({
              //   type: 'info',
              //   message: res.msg
              // })
            } else {
              if (res.content) {
                this.dialogFormVisible = true;
                this.dialogIndex = res.content.length;
                this.naticeData = res.content;
                for (let i = 0; i < this.naticeData.length; i++) {
                  this.thenId = this.naticeData[0].id
                  this.time = this.naticeData[0].read_time
                  this.contre = this.naticeData[0].content
                  this.titre = this.naticeData[0].title
                }
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 关闭弹窗
      closePop() {
        this.loading = true
        agreeNotice(this.thenId)
          .then(res => {
            this.loading = false;
            this.timeShow = true;
            this.closeShow = false;
            this.currentIndex++
            this.contre = this.naticeData[this.currentIndex].content
            this.titre = this.naticeData[this.currentIndex].title
            this.time = this.naticeData[this.currentIndex].read_time
            this.thenId = this.naticeData[this.currentIndex].id
            this.Time()

            // this.dialogFormVisible = false;
          })
          .catch(err => {
            console.log(err)
            this.loading = false
            // this.$message.error('网络错误，请稍后再试！')
          })
      },
      gotoGood() {
        localStorage.setItem('path', '/goods/Goods')
        let tag = {
          url: "/goods/Goods",
          menuname: "商品上架管理"
        }
        this.$bus.$emit("clearKeepAlive", tag);
        this.$store.commit('selectMenu', tag)
        this.$router.push({path: '/goods/Goods', query: {putaway_status: '75'}})
      },
      gotoAftersale() {
        localStorage.setItem('path', '/aftersale/Aftersale')
        let tag = {
          url: "/aftersale/Aftersale",
          menuname: "售后单管理"
        }
        this.$bus.$emit("clearKeepAlive", tag);
        this.$store.commit('selectMenu', tag)
        this.$router.push({path: '/aftersale/Aftersale', query: {audit_status: '260'}})
      },
      gotoOrder() {
        localStorage.setItem('path', '/order/AllOrder')
        let tag = {
          url: "/order/AllOrder",
          menuname: "订单管理"
        }
        this.$bus.$emit("clearKeepAlive", tag);
        this.$store.commit('selectMenu', tag)
        this.$router.push({path: '/order/AllOrder', query: {sendStatus: '0'}})
      },
    }
  }
</script>

<style scoped>
  .contianer {

  }

  .date-box {
    height: 96px;
    line-height: 96px;
    border-radius: 8px;
    padding-left: 25px;
    color: #333333;
    font-size: 20px;
    background: #fff;
    margin-bottom: 30px;
  }

  .flex-around {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
  }

  .head-message {
    width: 38%;
    background: #fff;
    height: 180px;
    border-radius: 8px;
    display: flex;
  }

  .product-message, .service-order-message, .send-goods-message {
    width: 18%;
    background: #fff;
    height: 180px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .product-message .text, .service-order-message .text, .send-goods-message .text {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .head {
    width: 130px;
    height: 130px;
    border-radius: 4px;
    margin: 25px;
  }

  .head img {
    width: 100%;
  }

  .person-message {
    margin-top: 45px;
  }

  .name {
    font-size: 28px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 20px;
  }

  .company-name {
    font-size: 20px;
    color: #333333;
  }

  .last-login-time {
    font-size: 14px;
    color: #999999;
    margin-top: 20px;
    margin-left: 35px;
  }

  .product-num {
    color: #409EFF;
    font-size: 36px;
    margin-right: 10px;
    cursor: pointer;
  }

  .service-order-num {
    color: #FF5757;
    font-size: 36px;
    margin-right: 10px;
    cursor: pointer;
  }

  .send-goods-num {
    color: #333;
    font-size: 36px;
    margin-right: 10px;
    cursor: pointer;
  }

  .table {
    border-radius: 8px;
    margin-bottom: 30px;
    padding: 20px;
    background: #fff;
  }

  .table-title {
    height: 56px;
    line-height: 56px;
    background: #fff;
    color: #409EFF;
    font-size: 16px;
  }

  .line {
    display: inline-block;
    width: 2px;
    height: 10px;
    background: #409EFF;
    border-radius: 1px;
    margin-right: 8px;
  }

  .absolute {
    position: absolute;
  }

  .relative {
    position: relative;
  }

  .box {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: inherit;
    background-color: rgba(242, 242, 242, 0.4980392156862745);
  }

  .borden {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50%;
    padding: 20px 40px;
    background: #fff;
    border-radius: 10px;
  }

  .text {
    text-align: center;
    font-size: 35px;
    color: #409EFF;
  }

  .condition {
    margin-top: 40px;
  }

  .tion {
    font-size: 20px;
    line-height: 50px;
  }

  .selected {
    margin-top: 50px;
    margin-bottom: 20px;
    text-align: center;
  }

  /deep/ .el-dialog__title {
    line-height: 24px;
    font-size: 18px;
    margin-top: 10px;
    color: #409EFF;
    font-size: 35px;
  }

  /deep/ .el-dialog__headerbtn {
      display: none;
  }

</style>





// WEBPACK FOOTER //
// src/views/dashboard/Dashboard.vue